'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./ChartNoData.scss');

var ChartNoData = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(ChartNoData, _PureComponent);

  function ChartNoData() {
    (0, _classCallCheck3.default)(this, ChartNoData);
    return (0, _possibleConstructorReturn3.default)(this, (ChartNoData.__proto__ || (0, _getPrototypeOf2.default)(ChartNoData)).apply(this, arguments));
  }

  (0, _createClass3.default)(ChartNoData, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;
      var t = this.context.t;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.container, className) },
        t('No data')
      );
    }
  }]);
  return ChartNoData;
}(_react.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string
}, _class.contextTypes = {
  t: _propTypes2.default.func
}, _temp);
exports.default = ChartNoData;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/ChartNoData/ChartNoData.js
// module id = 519
// module chunks = 1